import { IZiplogInfo } from '../models/IZiplogInfo';
import { Module } from '../Module';
import { ConfirmActionDialog } from '../services/ConfirmActionDialog';
import { ZiplogService, ZiplogState } from '../services/ZiplogService';

export interface IZiplogScope extends ng.IScope {
  remove: () => void;
  download: () => void;
  generate: () => void;
  isNoZiplog: () => boolean;
  isZiplogGenerating: () => boolean;
  isZiplogAvailable: () => boolean;
  state: string;
  ziplog: IZiplogInfo;

  confirmGenerateZiplogDialog: {
    daysToGenerate: number;
  };
}

export class ZiplogCtrl {

  private static DefaultZiplogDaysToGenerate = 7;

  private state: string;

  public static $inject = [
    '$scope',
    '$translate',
    'ZiplogService',
    'ConfirmActionDialog'
  ];

  constructor(private $scope: IZiplogScope,
              private $translate: ng.translate.ITranslateService,
              private ziplogService: ZiplogService,
              private ConfirmActionDialog: ConfirmActionDialog) {

    this.state = ZiplogState.NONE;

    ziplogService.getState().then((state: string) => {
      this.state = state;
      if (state !== ZiplogState.NONE) {
        this.getInfo();
      }
    });

    $scope.generate = () => this.confirmGenerateSnapshot();

    $scope.remove = () => {
      this.state = ZiplogState.NONE;
      $scope.ziplog = null;
      ziplogService.remove();
    };

    $scope.download = () => {
      ziplogService.download();
    };

    $scope.isNoZiplog = () => this.state === ZiplogState.NONE;
    $scope.isZiplogGenerating = () => this.state === ZiplogState.INPROGRESS;
    $scope.isZiplogAvailable = () => this.state === ZiplogState.COMPLETE;

    $scope.$on('$destroy', () => ziplogService.stopPolling());
  }

  private getInfo() {
    this.ziplogService.getInfo().then((ziplog: IZiplogInfo) => {
      this.state = ZiplogState.COMPLETE;
      this.$scope.ziplog = ziplog;
    });
  }

  private confirmGenerateSnapshot() {

    this.$scope.confirmGenerateZiplogDialog = {
      daysToGenerate: ZiplogCtrl.DefaultZiplogDaysToGenerate
    };

    this.ConfirmActionDialog.open({
      scope: this.$scope,
      title: this.$translate.instant('ziplog_newLogSnapshotDialog_title'),
      bodyTemplateUrl: 'ziplogNewLogSnapshotDialog.html',
      actionName: this.$translate.instant('ziplog_newLogSnapshotDialog_confirm'),
      action: () => {
        this.state = ZiplogState.INPROGRESS;
        this.ziplogService.generate(this.$scope.confirmGenerateZiplogDialog.daysToGenerate)
          .then(() => this.getInfo());
      }
    });
  }

}

Module.instance().controller('ZiplogCtrl', ZiplogCtrl);
